import { ACCEPT_TERMS_URL_PATTERN } from '@cli-constants/patterns.js'

export function findAcceptTermsUrl(line: string): string | undefined {
  return ACCEPT_TERMS_URL_PATTERN.exec(line)?.[0]
}
